import { render, staticRenderFns } from "./ActorRoleShow.vue?vue&type=template&id=4d3bddf9&"
import script from "./ActorRoleShow.vue?vue&type=script&lang=js&"
export * from "./ActorRoleShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports